import React, { useState, useEffect } from 'react';
import Drawer from '@material-ui/core/Drawer';
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../Dialog/Dialog';
import { connect } from 'react-redux';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { numberFormat, numberWithCommas, validNumberCheck, replaceCommas, findArrayObjectIndex } from '../../../utils/utils';
import * as logger from '../../../logger';
import {
    TextField,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete,
    Switches,
    Checkboxes
} from 'mui-rff';
import { Form } from 'react-final-form';
import {
    Grid,
    IconButton,
    Button,
    makeStyles
} from '@material-ui/core';
import { updateChatView } from "../../../store/actions/userActionCreators";
import { createBankDetails } from "../../../store/actions/authActionCreators";
import FailureDialog from '../Verfication/FailureDialog';
import TextInputState from '../Inputs/TextInputState';
import { sendError, sendSucces } from "../../../utils/utils"

const useStyles = makeStyles((theme) => ({

    transactionDetailsDrawer: {
        width: 420,
        maxWidth: 420,
        [theme.breakpoints.down('sm')]: {
            top: '56px!important',
            height: 'calc(100vh - 0px)'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px!important',
            height: 'calc(100vh - 0px)'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    modal: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    backdrop: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        }
    },
    dialogTitle: {
        paddingLeft: '30px !important',
        paddingRight: '18px !important',
        paddingTop: '8px !important',
        paddingBottom: '8px !important',
        '& .MuiTypography-root': {
            width: '100%'
        }
    },
    divTitle: {
        display: 'flex',
        alignItems: 'center',
        color: "#0b1323",
        fontSize: 20,
        marginBottom: 4,
        fontWeight: 600,
        letterSpacing: 'normal'
    },
    sideBarDialogContentV1: {
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 32,
        paddingLeft: 30,
        paddingRight: 30,
        paddingBottom: 20,
        backgroundColor: '#f6f6f8'
    },
    titleV1: {
        fontSize: '14px',
        fontWeight: 600,
        color: 'rgba(11, 19, 35, 0.75)'
    },
    mtV2: {
        marginTop: 4
    },
    mtV1: {
        marginTop: 16
    },
    textFieldV1: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            color: '#0b1323'
        }
    },
    dialogActions: {
        paddingTop: '20px !important',
        paddingBottom: '20px !important',
        paddingRight: '30px !important',
        paddingLeft: '30px !important',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    cancelButton: {
        padding: '6px 20px',
        borderRadius: '4px',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        border: 'solid 1px #d8dce6',
        background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        fontWeight: 300,
        textTransform: 'none',
        marginRight: 16,
        '&:hover': {
            background: 'linear-gradient(to top, #f6f7f9, #ffffff)'
        }
    },
    saveButton: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#09101e',
        fontSize: '14px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.71,
        letterSpacing: 'normal',
        color: '#ffffff',
        textTransform: 'none',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        '&:hover': {
            backgroundColor: '#09101e'
        }
    },
    saveButtonDisabled: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#dadada',
        fontSize: '14px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.71,
        letterSpacing: 'normal',
        color: '#5e636c',
        textTransform: 'none',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        marginLeft: '16px !important',
        '&:hover': {
            backgroundColor: '#dadada'
        }
    },

}));

const AddBankDetailsSideBar = ({
    open,
    onClose,
    onConfirm,
    user,
    dispatchChatView,
    dispatchCreateBankDetails
}) => {

    let submit;

    const [dialogOpen, setDialogOpen] = useState(open);
    const [confirmDisabled, setConfirmDisabled] = useState(false);
    const [accountNumberValue, setAccountNumberValue] = useState("");
    const [confirmAccountNumberValue, setConfirmAccountNumberValue] = useState("");
    const [accountHolderNameValue, setAccountHolderNameValue] = useState("");
    const [ifscCodeValue, setIfscCodeValue] = useState("");
    const [upiAddressValue, setUpiAddressValue] = useState("");
    const [ifscCodeValidation, setIfscCodeValidation] = useState(false);
    const [failureCreation, setFailureCreation] = useState(false);

    const classes = useStyles();

    const userDetails = user && user.userInfoProfile ? user.userInfoProfile : {};

    const initialValues = {
        accountNumber: accountNumberValue,
        confirmAccountNumber: confirmAccountNumberValue,
        accountHolderName: accountHolderNameValue,
        ifscCode: ifscCodeValue,
        upiAddress: upiAddressValue
    }

    useEffect(() => {

        dispatchChatView(false);

    }, [open]);

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div>
                        <div className={classes.titleV1}>Account Number</div>
                        <TextInputState
                            placeholder="Enter Account Number"
                            name="accountNumber"
                            variant="outlined"
                            size="small"
                            onChange={(e) => { setAccountNumberValue((e.target.value).toUpperCase()) }}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                )
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.mtV1} >
                        <div className={classes.titleV1}>Comfirm Account Number</div>
                        <TextInputState
                            placeholder="Enter Account Number"
                            name="confirmAccountNumber"
                            variant="outlined"
                            size="small"
                            onChange={(e) => { setConfirmAccountNumberValue((e.target.value).toUpperCase())}}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                )
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.mtV1}>
                        <div className={classes.titleV1}>Account Holder Name</div>
                        <TextInputState
                            placeholder="Enter Account Holder Name"
                            name="accountHolderName"
                            variant="outlined"
                            size="small"
                            onChange={(e) => { setAccountHolderNameValue(e.target.value) }}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                )
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.mtV1}>
                        <div className={classes.titleV1}>IFSC Code</div>
                        <TextInputState
                            placeholder="Enter IFSC Code"
                            name="ifscCode"
                            variant="outlined"
                            size="small"
                            onChange={(e) => {
                                setIfscCodeValidation(false)
                                setIfscCodeValue(e.target.value)
                            }}
                            onBlur={(e) => {
                                fetch("https://ifsc.razorpay.com/" + values.ifscCode)
                                    .then(function (response) {
                                        if (!response.ok) {
                                            throw Error(response.statusText);
                                        }
                                        return response.json();
                                    }).then(function (data) {
                                    }, (err) => {
                                        setIfscCodeValidation(true)
                                    }).catch(function (error) {
                                    });
                            }}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                )
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.mtV1}>
                        <div className={classes.titleV1}>UPI Address</div>
                        <TextInputState
                            placeholder="Enter UPI Address"
                            name="upiAddress"
                            variant="outlined"
                            size="small"
                            onChange={(e) => { setUpiAddressValue(e.target.value) }}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                )
            }
        ]
    }

    const validate = values => {
        const errors = {};

        const upiAddressRegex = userDetails && userDetails.configs && userDetails.configs.upi_id_regex ? new RegExp(userDetails.configs.upi_id_regex) : ""
        //const accountNumberRegex = new RegExp("^[0-9]{9,18}$");
        //const accountNumberRegex = new RegExp("^(?![a-zA-z]*$)([a-zA-Z0-9]{9,18})+$")
        const accountNumberRegex = new RegExp("^[a-zA-Z0-9]{9,30}$")
        if (!values.accountNumber) {
            errors.accountNumber = "Please enter Account Number."
        }

        if (!values.accountHolderName) {
            errors.accountHolderName = "Please enter Name of Account Holder"
        }

        if (!values.ifscCode) {
            errors.ifscCode = "Please enter IFSC code";
        }

        if (values.ifscCode && ifscCodeValidation) {
            errors.ifscCode = 'Invalid IFSC Code';
        }

        if (values.accountNumber && (!accountNumberRegex.test(values.accountNumber))) {
            errors.accountNumber = "Invalid Account Number."
        }

        if (values.upiAddress && (upiAddressRegex && !upiAddressRegex.test(values.upiAddress))) {
            errors.upiAddress = "Please enter a Valid UPI Address"
        }

        if (values.accountNumber != values.confirmAccountNumber) {
            errors.confirmAccountNumber = "Account No. and Confirm Account No. do not Match"
        }

        if (errors && Object.keys(errors).length !== 0 && errors.constructor === Object) {
            setConfirmDisabled(true);
        } else {
            setConfirmDisabled(false);
        }

        return errors;
    }

    const onSubmit = async values => {
        fetch("https://ifsc.razorpay.com/" + values.ifscCode)
            .then(function (response) {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(function (data) {

                const accountData = {
                    acc_number: accountNumberValue ? accountNumberValue : "",
                    ifsc_code: ifscCodeValue ? ifscCodeValue : "",
                    acc_holder_name: accountHolderNameValue ? accountHolderNameValue : "",
                    entity_type: "FLEET_OWNER",
                    upi_address: upiAddressValue ? upiAddressValue : "",
                    entity_id: userDetails && userDetails.entityId ? userDetails.entityId : "",
                    userId: userDetails && userDetails.id ? userDetails.id : ""
                }

                if (data && data.BANK) {
                    accountData.bank_name = data.BANK;
                }

                dispatchCreateBankDetails(accountData,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log('Add Bank Details Side Bar Dweb', 'Create Bank Details Successfull');
                            if (data && data.status && data.status.code == 200) {
                                sendSucces("Bank Account Added Successfully");
                                onConfirm(data && data.response && data.response.broker_verification_status ? data.response.broker_verification_status : false);
                            } else {
                                onConfirm(false);
                            }
                        }
                    },
                    () => {
                        logger.log('Add Bank Details Side Bar Dweb', 'Create Bank Details Failed');
                        onConfirm(false);
                    }
                )
            }, (err) => {
                handleFailureOpen();
            }).catch(function (error) {
            });
    }

    const handleFailureOpen = () => {
        setFailureCreation(true)
    }

    const handleFailureClose = () => {
        setFailureCreation(false)
    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    return (
        <>
            <Drawer
                variant="temporary"
                anchor="right"
                open={dialogOpen}
                ModalProps={{
                    keepMounted: false,
                    className: classes.modal,
                    BackdropProps: {
                        className: classes.backdrop
                    },
                    disableBackdropClick: true,
                    disableEscapeKeyDown: true,
                    //onBackdropClick: handleClose
                }}
                classes={{
                    paper: classes.transactionDetailsDrawer
                }}
            >
                <SideBarDialogTitle id={"right-sidebar-for-add-bank-details"} onClose={handleClose} className={classes.dialogTitle} >
                    <div className={classes.divTitle}>
                        Bank Details
                    </div>
                </SideBarDialogTitle >

                <SideBarDialogContent dividers className={classes.sideBarDialogContentV1} >

                    <Form
                        onSubmit={onSubmit}
                        initialValues={initialValues}
                        validate={validate}
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit; return (
                                <form onSubmit={handleSubmit} noValidate>
                                    <Grid container alignItems="flex-start" spacing={0}>
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />

                </SideBarDialogContent>

                <SideBarDialogActions className={classes.dialogActions} >

                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()}>
                        Cancel
                    </Button>
                    <Button variant="contained" className={classes.saveButton} classes={{ disabled: classes.saveButtonDisabled }} disabled={confirmDisabled}
                        onClick={event => submit(event)}
                    >
                        Save
                    </Button>

                </SideBarDialogActions>
            </Drawer>

            {failureCreation && <FailureDialog open={failureCreation} title={"IFSC Code Failed"} subTitle={"Please Re-Check the Bank Account details"} onClose={handleFailureClose} />}
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dispatchChatView: (value) => dispatch(updateChatView(value)),
    dispatchCreateBankDetails: (accountData, onSuccess, onFailure) => {
        dispatch(createBankDetails(accountData, onSuccess, onFailure))
    }

});

export default connect(mapStateToProps, mapDispatchToProps)(AddBankDetailsSideBar);